export const API_URL: string = process.env.REACT_APP_API_URL as string;
export const LOCAL_MODE: boolean = process.env.REACT_APP_LOCAL_MODE == '1';
export const REMOTE_API_URL: string = process.env.REACT_APP_API_REMOTE_URL as string;
export const DEBUG_MODE: boolean = process.env.REACT_APP_DEBUG === 'true';
export const DEBUG_ENV_LABEL: string = process.env.REACT_APP_ENV_LABEL || 'Desarrollo';
export const DEBUG_HOST_LABEL: string = process.env.REACT_APP_HOST_LABEL || window.location.host;
